import { render } from "./VirtualClassroom.vue?vue&type=template&id=f12a9e40&ts=true"
import script from "./VirtualClassroom.vue?vue&type=script&lang=ts"
export * from "./VirtualClassroom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__